import { CheckCircleIcon } from '@heroicons/react/24/solid';

/**
 * Small per-field status indicator for the intake form.
 *
 * - 'complete' / 'prefilled' -> solid green check (reassurance that the field is good)
 * - 'missing'                -> calm amber dot with a soft halo (the "do this next" cue)
 * - anything else            -> nothing
 *
 * The component only renders the mark; the parent positions it (as an absolute
 * overlay inside a `relative` input wrapper, or inline in the label row for
 * <select> fields whose native chevron would collide with an overlay).
 */
export default function FieldStatusIcon({ status, className = '' }) {
  if (status === 'complete' || status === 'prefilled') {
    return (
      <CheckCircleIcon
        className={`h-5 w-5 text-green-600 ${className}`}
        aria-hidden="true"
      />
    );
  }

  if (status === 'missing') {
    return (
      <span
        className={`inline-flex h-2 w-2 rounded-full bg-amber-500 ring-4 ring-amber-100 motion-safe:animate-pulse ${className}`}
        aria-hidden="true"
      />
    );
  }

  return null;
}
